import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const AdminNav: React.FC = () => {
  const location = useLocation();

  const links = [
    { to: '/admin', label: 'Dashboard' },
    { to: '/admin/users', label: 'Users' },
    { to: '/admin/statistics', label: 'Statistics' },
    { to: '/admin/audit', label: 'Audit Log' }
  ];

  return (
    <div className="mt-2 border-b border-gray-200">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        {links.map(link => {
          const isActive = location.pathname === link.to;
          return (
            <NavLink
              key={link.to}
              to={link.to}
              className={
                isActive
                  ? 'border-indigo-500 text-indigo-600 whitespace-nowrap py-2 px-1 border-b-2 text-sm font-medium'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap py-2 px-1 border-b-2 text-sm font-medium'
              }
            >
              {link.label}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};

export default AdminNav;

